<select-search-component
      [api_model]="'component_type'"
      [value]="componentTypeID"
      [compareFunctionName]="'compareValueToId'"
      (selectionChange)="setComponentType($event.value.id)"
      [classes]="'fill'" [disabled]="readonly"
      [noItemsAvailableMessage]="'No results. Please create at least one Component Type to use this upload type.'"
      [label]="'Select Component Type'"
  ></select-search-component>
